import { Formik } from 'formik';
import {
	MimaButton,
	MimaDropdown,
	MimaText,
	Modal,
	PageLoader,
} from '../../components';
import React, { useState } from 'react';
import { businessStore } from '../../stores';

const RenewSub = ({
	closeModal,
	validationSchema,
	onSubmit,
	loading,
	monthData,
	plansData,
	plan,
	setPlan,
}) => {
	const { business } = businessStore;

	return (
		<Modal closeModal={closeModal}>
			<MimaText variant="subtitle" mb={4}>
				Renew Your Subscription
			</MimaText>

			{loading ? (
				<PageLoader loading={loading} />
			) : (
				<>
					<MimaText width={38} mb={3} align="center">
						Hello {business.tradingName}, Renew your subscription to the{' '}
						<b>{business.plan.name} plan</b> or Select a new plan
					</MimaText>

					<Formik
						initialValues={{
							months: '',
							plan: business.plan._id,
						}}
						validationSchema={validationSchema}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<>
								<MimaDropdown
									labelTitle="Select Plan"
									placeholder={business.plan.name}
									id="plan"
									name="plan"
									value={values.plan}
									onChange={data => {
										setFieldValue('plan', data.key);
										setPlan(data);
									}}
									onBlur={handleBlur}
									error={errors.plan}
									touched={touched.plan}
									data={plansData}
								/>

								<MimaDropdown
									labelTitle="Select Months"
									placeholder="Select months"
									id="months"
									name="months"
									value={values.months}
									onChange={data => {
										setFieldValue('months', data.key);
									}}
									onBlur={handleBlur}
									error={errors.months}
									touched={touched.months}
									data={monthData}
								/>

								<MimaButton
									title="Renew Subscription"
									onClick={handleSubmit}
									type="submit"
									loading={loading}
								/>
							</>
						)}
					</Formik>
				</>
			)}
		</Modal>
	);
};

export default RenewSub;
